<template>

    <div class="dialog-shade-mod">
        <div class="update-dialog-mod">
            <div v-bind:class="[ errorTips ? 'errorTips' : '', 'video-name rel' ]">
                <input type="text" class="ui-input" placeholder="Video name" v-model="title" />
                <p class="ui-error">{{ $t( 'dialog.updateTitle' ) }}</p>
            </div>
            <button id="save-button" :disabled="errorTips" v-on:click="confirmUpdate" class="ui-button primary-button short-button">{{ $t('dialog.save') }}</button>
            <button id="cancle-button" v-on:click="cancleUpdate" class="ui-button empty-button short-button">{{ $t('dialog.cancel') }}</button>
        </div>
    </div>
    
</template>

<script>

export default {

    props: {

        value: {
            type: String,
            require: true
        },
        updateTitle: {
            type: Boolean,
            require: true
        }

    },

    data () {

        return {

            title: this.value,
            errorTips: false

        };

    },

    watch: {

        title ( val ) {

            if ( val.length > 127 ) {

                this.errorTips = true;

            } else {

                this.errorTips = false;

            }

        }

    },

    methods: {

        confirmUpdate () {

            this.$emit( 'input', this.title );
            this.$emit( 'updateTitleState', false );
  
        },

        cancleUpdate () {

            this.$emit( 'updateTitleState', false );

        }

    }
  
};

</script>

<style>

    .update-dialog-mod{
        margin-bottom: .2rem;
    }

    .update-dialog-mod .video-name{
        display: inline-block;
        width: 8.4rem;
        margin-right: .3rem;
    }

    .update-dialog-mod .ui-input{
        width: 100%;
    }

    #save-button{
        margin-bottom: 0;
        margin-right: .2rem;
    }

    #cancle-button{
        margin: 0;
    }

    @media screen and ( max-width: 1199px ) {

        .update-dialog-mod{
            position: absolute;
            width: calc( 100% - 30px );
            padding: .6rem .5rem;
            box-sizing: border-box;
            margin: 0 auto;
            text-align: center;
            transform: translate(-50%,-50%);
            top: 50%;
            left: 50%;
            background-color: #fff;
            border-radius: .2rem;
            position: fixed;
        }

        .update-dialog-mod .video-name{
            display: block;
            width: 100%;
        }

        .update-dialog-mod .ui-input{
            width: 100%;
            margin-right: 0;
        }

        .dialog-shade-mod{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, .6);
            z-index: 8;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/updateDialog.vue